module.exports = __webpack_public_path__ + "img/WhiteTriangle.57fb484c.svg";